export enum KeyboardSpecialKeyTypes {
  InputTyping = 'input-typing',
  Backspace = 'backspace',
  Delete = 'delete',
  Tab = 'tab',
  Clear = 'clear',
  Enter = 'enter',
  Escape = 'escape',
  Left = 'left',
  Down = 'down',
  Up = 'up',
  Right = 'right',
  Space = 'space',
}
